import { Button, Card, CardActions, CardContent, Typography } from "@mui/material"
import './PricingCard.css'
import { useNavigate } from "react-router-dom";

const PricingCard = (props) => {
    let navigate = useNavigate();
    return (
        <Card
            className={`pricing-card pretty-text ${props.highlight ? 'highlighted' : ''}`}
            variant="outlined"
        >
            <CardContent>
                <Typography
                    variant="h4"
                    component="div"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: 'text.primary'
                    }}
                >
                    {props.labels.title}
                </Typography>
                <Typography
                    variant="subtitle1"
                    sx={{ color: "rgba(255,255,255,0.8)" }}
                    gutterBottom
                >
                    {props.labels.subtitle}
                </Typography>

                <ul style={{ paddingLeft: "1.2rem", marginBottom: 0 }}>
                    {props.labels.features.map((label, i) => (
                        <li
                            key={`li-${props.id}-${i}`}
                            style={{
                                marginBottom: "0.5rem",
                                color: "rgba(255,255,255,0.7)",
                                fontSize: "0.9rem",
                            }}
                        >
                            {label}
                        </li>
                    ))}
                </ul>
            </CardContent>
            <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                <Button
                    variant={props.highlight ? "contained" : "outlined"}
                    color={props.highlight ? "primary" : "inherit"}
                    disabled={!props.highlight}
                    size="large"
                    onClick={() => navigate(props.cta_url || "")}
                >
                    {props.labels.cta}
                </Button>
            </CardActions>
        </Card>
    )
}

export default PricingCard